// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-container {
    width: 100%;
    max-width: 500px;
    margin: 10px auto;
    text-align: center;
  }
  
  .timer-text {
    font-size: 18px;
    margin-bottom: 5px;
  }
  
  .progress-bar {
    width: 100%;
    height: 5px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .progress {
    height: 100%;
    background-color: #000;
    transition: width 1s linear;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/CountDown.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;EAC7B","sourcesContent":[".timer-container {\n    width: 100%;\n    max-width: 500px;\n    margin: 10px auto;\n    text-align: center;\n  }\n  \n  .timer-text {\n    font-size: 18px;\n    margin-bottom: 5px;\n  }\n  \n  .progress-bar {\n    width: 100%;\n    height: 5px;\n    background-color: #fff;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  .progress {\n    height: 100%;\n    background-color: #000;\n    transition: width 1s linear;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
